import React, { useState, useEffect, useContext, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from './AuthContext'
import { setApplicationName } from '../../lib/amplitudeClient'

const CloudContext = React.createContext()

const CloudProvider = ({ children }) => {
    const { user } = useContext(AuthContext)
    const navigate = useNavigate()
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [actAsCloud, setActAsCloud] = useState(null)

    useEffect(() => {
        const index = localStorage.getItem('cloudIndex')
        setSelectedIndex(index || 0)
    }, [])

    const clouds = useMemo(
        () =>
            user
                ? actAsCloud
                    ? Object.entries(user.permissions)
                          .filter(([key, val]) => val > 3 || key == actAsCloud)
                          .map(([key, val]) => key)
                          .sort()
                    : Object.entries(user.permissions)
                          .filter(([key, val]) => val > 3)
                          .map(([key, val]) => key)
                          .sort()
                : [],
        [user]
    )
    const selectedCloud = actAsCloud ? actAsCloud : clouds[selectedIndex] || clouds[0]

    useEffect(() => {
        if (!clouds.length) return
        setApplicationName(clouds[selectedIndex])
    }, [selectedCloud])

    const changeCloud = index => {
        localStorage.setItem('cloudIndex', index)
        setSelectedIndex(index)
        navigate('/', { replace: true }) // go back to home page
    }

    return (
        <CloudContext.Provider value={{ clouds, selectedCloud, changeCloud, setActAsCloud }}>
            {children}
        </CloudContext.Provider>
    )
}

export { CloudContext, CloudProvider }
